import React from 'react';
import { motion } from 'framer-motion';

// ── Variants ────────────────────────────────────────────────────────────────

const section = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.18, delayChildren: 0.05 } },
};

const fadeUp = {
  hidden: { opacity: 0, y: 52 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 1.1, ease: [0.22, 1, 0.36, 1] },
  },
};

const fadeLeft = {
  hidden: { opacity: 0, x: -24 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.72, ease: [0.22, 1, 0.36, 1] },
  },
};

const statsRow = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.12, delayChildren: 0.1 } },
};

const statPop = {
  hidden: { opacity: 0, y: 28, scale: 0.95 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.65, ease: [0.22, 1, 0.36, 1] },
  },
};

// ── Component ────────────────────────────────────────────────────────────────

export const AboutSection = () => (
  <section
    id="about"
    data-testid="about-adam-section"
    className="relative overflow-hidden py-24 sm:py-32"
    style={{ backgroundColor: 'rgba(0,0,0,0.82)' }}
  >
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
      <motion.div
        variants={section}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: '-90px' }}
      >

        {/* Label */}
        <motion.div
          variants={fadeLeft}
          className="inline-flex items-center gap-2 mb-6"
          style={{
            fontFamily: 'DM Sans',
            color: '#6B7280',
            letterSpacing: '2px',
            textTransform: 'uppercase',
            fontSize: '11px',
            fontWeight: 500,
          }}
        >
          About Adam
        </motion.div>

        {/* Heading */}
        <motion.h2
          variants={fadeUp}
          className="text-5xl sm:text-6xl font-bold mb-8 leading-tight"
          style={{ fontFamily: 'Cormorant Garamond', color: '#FFFFFF', letterSpacing: '-0.02em' }}
        >
          Quantitative Analyst
          <br />
          <span style={{ color: '#1E40AF' }}>Algorithmic Trading Specialist</span>
        </motion.h2>

        {/* Body paragraphs — each one staggers in */}
        <motion.p variants={fadeUp} className="text-lg leading-relaxed mb-5" style={{ color: '#D1D5DB', fontFamily: 'DM Sans' }}>
          Adam is a quantitative analyst with over 12 years of experience building proprietary algorithmic trading systems.
        </motion.p>
        <motion.p variants={fadeUp} className="text-lg leading-relaxed mb-5" style={{ color: '#D1D5DB', fontFamily: 'DM Sans' }}>
          He specializes in developing institutional-grade strategies and providing access to proprietary firm capital for qualified traders.
        </motion.p>
        <motion.p variants={fadeUp} className="text-lg leading-relaxed mb-12" style={{ color: '#D1D5DB', fontFamily: 'DM Sans' }}>
          His focus: systematic trading with quantifiable edge, executed through fully automated systems.
        </motion.p>

        {/* Divider */}
        <motion.div
          variants={fadeUp}
          className="pt-12 border-t"
          style={{ borderColor: 'rgba(255,255,255,0.1)' }}
        >
          <motion.div
            className="grid grid-cols-3 gap-8"
            variants={statsRow}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: '-60px' }}
          >
            {[
              { value: '12+', label: 'Years' },
              { value: '$10M+', label: 'Systems Managed' },
              { value: '100%', label: 'Algorithmic' },
            ].map((stat, i) => (
              <motion.div key={i} variants={statPop}>
                <div
                  className="text-4xl font-bold mb-2"
                  style={{ fontFamily: 'Cormorant Garamond', color: '#FFFFFF' }}
                >
                  {stat.value}
                </div>
                <div
                  className="text-xs"
                  style={{ fontFamily: 'DM Sans', color: '#6B7280', letterSpacing: '0.1em', textTransform: 'uppercase' }}
                >
                  {stat.label}
                </div>
              </motion.div>
            ))}
          </motion.div>
        </motion.div>

      </motion.div>
    </div>
  </section>
);
